import { TmApiNotFoundError } from '@/core/error/transport/tmApiNotFoundError'

export class TmApiTaskChecklistNotFoundError extends TmApiNotFoundError {
  public name = 'TmApiTaskChecklistNotFoundError'
}
